module.exports = __webpack_public_path__ + "static/img/tarde.122abc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tarde.png
// module id = YC79
// module chunks = 1